import React, { FC } from 'react';
import { useTranslate } from 'react-admin';
import { SelectInput } from '~/components';
import cx from 'classnames';
import { useGetLedgerSystems } from '~/hooks/product';

export const MappingSystemFilter: FC<{
  name: string;
  label?: string;
  value: any;
  onChange: (e: any) => void;
  className?: string;
  [x: string]: any;
}> = (props) => {
  const { name, value, onChange, className, label, ...rest } = props;
  const translate = useTranslate();
  const t = (key: string): string => translate(`resources.transfers.filters.${key}`);
  const { data: systems, isLoading: systemsLoading } = useGetLedgerSystems();
  const options =
    systems?.map((system) => ({
      value: system,
      text: system,
    })) || [];
  return (
    <SelectInput
      label={label || t('ledgerSystem')}
      name={name}
      value={value}
      className={cx(className)}
      options={options}
      allowEmpty
      onChange={onChange}
      disabled={systemsLoading}
      {...rest}
    />
  );
};

export default MappingSystemFilter;
